import { render, staticRenderFns } from "./certificationList.vue?vue&type=template&id=a0dd8262&"
import script from "./certificationList.vue?vue&type=script&lang=js&"
export * from "./certificationList.vue?vue&type=script&lang=js&"
import style0 from "./certificationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports